import { polyvoxUrl, trackPolyvoxClick } from '../utils/polyvox';

export default function PolyvoxPromo({ placement, language }) {
  const href = polyvoxUrl(placement);
  const lang = typeof language === 'string' ? language.trim() : '';
  const headline = lang
    ? `Hear your voice speak ${lang}`
    : 'Speak any language in your own voice';

  return (
    <aside className="polyvox-promo">
      <p className="polyvox-kicker">Also from us · Polyvox</p>
      <p className="polyvox-headline">{headline}</p>
      <p className="polyvox-body">
        Clone a 30-second sample and hear it in 75 languages — same voice, native pronunciation.
      </p>
      <a
        className="polyvox-cta"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackPolyvoxClick(placement, lang ? { language: lang } : undefined)}
      >
        Try Polyvox
      </a>
    </aside>
  );
}
